import React, { useState } from 'react';
import { Row, Col, Button, Space } from 'antd';
import { TweenOneGroup } from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { DoubleRightOutlined } from '@ant-design/icons';
import { getChildrenToRender } from '@/utils';
import Feature6 from './Feature6';
import { useTranslation } from 'react-i18next';

function Content5(props) {
  const { isAll = false } = props;
  const { t } = useTranslation();
  const oemImagesContext = require.context('@/assets/customer/oem', false, /\.(png|jpg)$/);
  const partImagesContext = require.context('@/assets/customer/part', false, /\.(png|jpg|)$/);
  const internetImagesContext = require.context('@/assets/customer/internet', false, /\.(png|jpg)$/);
  const partnerImagesContext = require.context('@/assets/customer/partner', false, /\.(png|jpg)$/);
  const oemImages = oemImagesContext.keys().map(path => path.replace('./', ''));
  const partImages = partImagesContext.keys().map(path => path.replace('./', ''));
  const internetImages = internetImagesContext.keys().map(path => path.replace('./', ''));
  const partnerImages = partnerImagesContext.keys().map(path => path.replace('./', ''));
  const getOemChildren = () => {
    let arr = activeIndex === 0 ? oemImages.filter(image => image.includes('c')) : oemImages.filter(image => image.includes('f'));
    return arr.map((item, index) => {
      return (
        <Col key={index} className="block" md={4} xs={12}>
          <a className="content5-block-content">
            <img src={require('@/assets/customer/oem/' + item)} alt="img" />
          </a>
        </Col>
      );
    });

  };

  const getPartChildren = () => {
    let arr = activeIndex === 0 ? partImages.filter(image => image.includes('c')) : partImages.filter(image => image.includes('f'));
    return arr.map((item, index) => {
      return (
        <Col key={index} className="block" md={4} xs={12}>
          <a className="content5-block-content">
            <img src={require('@/assets/customer/part/' + item)} alt="img" />
          </a>
        </Col>
      );
    });
  };

  const getInternetChildren = () => {
    let arr = activeIndex === 0 ? internetImages.filter(image => image.includes('c')) : internetImages.filter(image => image.includes('f'));
    return arr.map((item, index) => {
      return (
        <Col key={index} className="block" md={4} xs={12}>
          <a className="content5-block-content">
            <img src={require('@/assets/customer/internet/' + item)} alt="img" />
          </a>
        </Col>
      );
    });
  };
  const getPartnerChildren = () => {
    let arr = activeIndex === 0 ? partnerImages.filter(image => image.includes('c')) : partnerImages.filter(image => image.includes('f'));
    return arr.map((item, index) => {
      return (
        <Col key={index} className="block" md={4} xs={12}>
          <a className="content5-block-content">
            <img src={require('@/assets/customer/partner/' + item)} alt="img" />
          </a>
        </Col>
      );
    });
  };

  const [activeIndex, setActiveIndex] = useState(0);

  const handleChildClick = (data) => {
    setActiveIndex(data);
  };

  const { dataSource, ...restProps } = props;

  return (
    <div {...restProps} {...dataSource.wrapper}>
      <div {...dataSource.page}>
        <div key="title" {...dataSource.titleWrapper}>
          {dataSource.titleWrapper.children.map((val, i) => getChildrenToRender(val, i, t))}
        </div>
        <OverPack
          className={`content-template ${props.className}`}
          {...dataSource.OverPack}
        >
          <Feature6 isMobile={props.isMobile} dataSource={props.contentDataSource} onTitleClick={handleChildClick} />
          {isAll && <div className="con">
            <label>{t('about.mainEnginePlant')}</label>
          </div>}
          <TweenOneGroup
            component={Row}
            key="oemUl"
            enter={{
              y: '+=30',
              opacity: 0,
              type: 'from',
              ease: 'easeInOutQuad'
            }}
            leave={{ y: '+=30', opacity: 0, ease: 'easeInOutQuad' }}
            {...dataSource.block}
          >
            {getOemChildren()}
          </TweenOneGroup>
          {
            isAll ? (
              <>
                <div className="con">
                  <label>{t('about.partPlant')}</label>
                </div>
                <TweenOneGroup
                  component={Row}
                  key="partUl"
                  enter={{
                    y: '+=30',
                    opacity: 0,
                    type: 'from',
                    ease: 'easeInOutQuad'
                  }}
                  leave={{ y: '+=30', opacity: 0, ease: 'easeInOutQuad' }}
                  {...dataSource.block}
                >
                  {getPartChildren()}
                </TweenOneGroup>
                <div className="con">
                  <label>{t('about.internet')}</label>
                </div>
                <TweenOneGroup
                  component={Row}
                  key="internetUl"
                  enter={{
                    y: '+=30',
                    opacity: 0,
                    type: 'from',
                    ease: 'easeInOutQuad'
                  }}
                  leave={{ y: '+=30', opacity: 0, ease: 'easeInOutQuad' }}
                  {...dataSource.block}
                >
                  {getInternetChildren()}
                </TweenOneGroup>
                <div className="con">
                  <label>{t('about.partner')}</label>
                </div>
                <TweenOneGroup
                  component={Row}
                  key="partnerUl"
                  enter={{
                    y: '+=30',
                    opacity: 0,
                    type: 'from',
                    ease: 'easeInOutQuad'
                  }}
                  leave={{ y: '+=30', opacity: 0, ease: 'easeInOutQuad' }}
                  {...dataSource.block}
                >
                  {getPartnerChildren()}
                </TweenOneGroup></>
            ) : (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '30px' }}>
                <Button href="/about" size="large" shape="round">
                  {t('home.learnMore')}<DoubleRightOutlined />
                </Button>
              </div>
            )
          }
        </OverPack>
      </div>
    </div>
  );
}

export default Content5;
